<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ title }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" @click="create">New</base-button>
          <base-button size="sm" type="neutral" v-b-toggle.filters>
            <span class="btn-inner--icon"><i class="fas fa-filter"></i></span>
            <span class="btn-inner--text">Filters</span>
          </base-button>
          <base-button size="sm" type="neutral" v-b-toggle.stats>
            <span class="btn-inner--icon"><i class="fas fa-chart-pie"></i></span>
            <span class="btn-inner--text">Stats</span>
          </base-button>
          <base-button size="sm" type="neutral" v-b-toggle.leads-sidebar v-if="fubIntegration">
            <span class="btn-inner--icon"><img src="/img/fub/fub-icon.png" /></span>
              <span class="btn-inner--text"></span>
          </base-button>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-collapse visible id="stats">
        <pipeline-stats
          :year="year"
          :type="type"
          :rating="rating"
          :status="status"
          :transferred="transferred"
          :userRoute="userRoute"
          @updateRating="updateRating">
        </pipeline-stats>
      </b-collapse>

      <pipelines-table 
        :title="title"
        :data="pipelines"
        :tableColumns="columns"
        :propsToSearch="propsToSearch"
        :types="types"
        :statuses="statuses"
        :variants="variants"
        :canAddEdit="true"
        :userRoute="userRoute"
        @getItems="getItems"
        @updateType="updateType"
        @updateStatus="updateStatus"
        @updateRating="updateRating"
        @updateTransferred="updateTransferred"
        @exportPipeline="exportPipeline"
        v-if="pipelines"></pipelines-table>
        <loading-panel v-else class="mt-6"></loading-panel>
    </b-container>
    <leads-sidebar v-if="fubIntegration"></leads-sidebar>
  </div>
</template>
<script>
// Components
import axios from 'axios';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import LoadingPanel from '@/components/LoadingPanel';
import PipelineStats from '@/views/Components/Stats/PipelineStats';
import PipelinesTable from '@/views/Components/Tables/PipelinesTable';
import columns from './columns';
import LeadsSidebar from '@/views/Components/FUB/LeadsSidebar';

export default {
  components: {
    RouteBreadCrumb,
    LoadingPanel,
    PipelineStats,
    PipelinesTable,
    LeadsSidebar
  },
  data() {
    return {
      pipelines: null,
      columns: columns,
      propsToSearch: [],
      year: new Date().getFullYear(),
      sortBy: 'close_date',
      type: '',
      rating: '',
      status: '',
      transferred: 0,
      types: [
        {
          value: 'listing',
          label: 'Listing'
        },
        {
          value: 'buyer',
          label: 'Buyer'
        }
      ],
      statuses: [
        {
          value: 'Active',
          label: 'All Active'
        },
        {
          value: 'Nurture',
          label: 'Nurture'
        },
        {
          value: 'Appt Set',
          label: 'Appt Set'
        },
        {
          value: 'Appt Held',
          label: 'Appt held'
        },
        {
          value: 'Agreement Signed',
          label: 'Aggreement Signed'
        },
        {
          value: 'Listing Taken',
          label: 'Listing Taken'
        },
        {
          value: 'Sold',
          label: 'Sold'
        },
        {
          value: 'Out',
          label: 'Out'
        }
      ],
      variants: {
        listing: 'success',
        buyer: 'info'
      }
    };
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      integrations: 'integrations/integrations',
    }),
    title() {
      return 'Sales Pipeline';
    },
    fubIntegration() {
      return this.integrations.filter(integration => {
        return integration.name == 'follow-up-boss';
      })[0];
    }
  },
  methods: {
    async getItems() {
      axios.get(this.userRoute + "/pipelines?year=" + this.year + "&type=" + this.type + "&rating=" + this.rating + "&status=" + this.status + "&transferred=" + this.transferred)
      .then(response => {
        this.pipelines = response.data;

      });
    },
    create() {
      this.$router.push({path: '/pipelines/create'});
    },
    updateYear(year) {
      this.year = year;
    },
    updateType(type) {
      this.type = type;

      if (!this.$route.query.type || this.$route.query.type !== type) {
          this.$router.replace({path: this.$route.path, query: {...this.$route.query, type: type}});
      }
    },
    updateStatus(status) {
      this.status = status;

      if (!this.$route.query.status || this.$route.query.status !== status) {
          this.$router.replace({path: this.$route.path, query: {...this.$route.query, status: status}});
      }
    },
    updateRating(rating) {
      this.rating = rating;
      this.status = 'Active';

      if (!this.$route.query.rating || this.$route.query.rating !== rating) {
          this.$router.replace({path: this.$route.path, query: {...this.$route.query, rating: rating}});
      }
    },
    updateTransferred(transferred) {
      this.transferred = transferred;

      if (!this.$route.query.transferred || this.$route.query.transferred !== transferred) {
          this.$router.replace({path: this.$route.path, query: {...this.$route.query, transferred: transferred}});
      }
    },
    async exportPipeline() {
      axios.get(this.userRoute + "/export-pipeline?year=" + this.year + "&type=" + this.type + "&rating=" + this.rating + "&status=" + this.status + "&transferred=" + this.transferred)
      .then(response => {
        swal.fire({
          title: 'Export Complete',
          text: response.data.message,
          icon: 'success',
          confirmButtonColor: '#009347',
          confirmButtonText: 'Download Sales Pipeline',
        }).then(result => {
          if (result.value) {
            window.open(response.data.link, "_blank");
          }
        });
      })
      .catch(error => {
        // 
      })
    }
  },
  created() {
    if (this.$route.query.rating) {
      this.rating = this.$route.query.rating;
    }
    
    this.getItems();
  },
  mounted() {
    document.title = this.title + " | ClarityNOW";
  },
  watch: {
    year(to, from) {
      this.getItems();
    },
    type(to, from) {
      this.getItems();
    },
    rating(to, from) {
      this.getItems();
    },
    status(to, from) {
      this.getItems();
    },
    transferred(to, from) {
      this.getItems();
    }
  }
};
</script>
<style lang="scss">
.fa-info-circle {
  position: absolute;
  top: 3px;
  right: 3px;
}
</style>